import { render, staticRenderFns } from "./TimeclockOrderTabPause.vue?vue&type=template&id=94c0f1ea&"
import script from "./TimeclockOrderTabPause.vue?vue&type=script&lang=ts&"
export * from "./TimeclockOrderTabPause.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports